import { render, staticRenderFns } from "./CandidatesChoosePayment.vue?vue&type=template&id=3ca399c8&lang=pug&"
import script from "./CandidatesChoosePayment.vue?vue&type=script&lang=js&"
export * from "./CandidatesChoosePayment.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesChoosePayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VRadio,VRadioGroup,VTextarea})
